import {
  getFilingPaymentIntent,
  getSubscriptionSetupIntent,
} from "../../../../../api/payments/subscriptionsAPI";

export const PAYMENT_STRATEGIES = {
  RECURRING: {
    initializeIntent: ({ purchaseId }) =>
      getSubscriptionSetupIntent({
        subscription_id: purchaseId,
      }),

    confirmIntent: async ({
      stripe,
      elements,
      returnUrl,
      isTestAccount,
      isUpgradeDowngradePlan,
    }) => {
      const finalReturnUrl = isUpgradeDowngradePlan
        ? `${returnUrl}&action=upgrade`
        : returnUrl;

      if (isTestAccount) {
        window.location.href = `${finalReturnUrl}&redirect_status=succeeded`;
        return { error: null };
      }

      return stripe.confirmSetup({
        elements,
        confirmParams: {
          return_url: finalReturnUrl,
        },
      });
    },
  },

  ONE_TIME: {
    initializeIntent: ({ purchaseId }) =>
      getFilingPaymentIntent({
        filingUuid: purchaseId,
      }),

    confirmIntent: async ({ stripe, elements, returnUrl, isTestAccount }) => {
      if (isTestAccount) {
        window.location.href = `${returnUrl}&redirect_status=succeeded`;
        return { error: null };
      }

      return stripe.confirmPayment({
        elements,
        confirmParams: {
          return_url: returnUrl,
        },
      });
    },
  },
};
